<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">发票管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="title_box flex-box flex-between fs18">
                    <div class="col90">修改发票抬头</div>
                    <div class="back col12 cursor flex-box" @click="pageBack">返回</div>
                </div>
                <div class="form_box">
                    <div class="flex-box mb25 fs16 col04">
                        <div class="title must relative">抬头类型</div>
                        <div class="type fwb">企业单位</div>
                    </div>
                    <div class="title must fs16 col04 relative mb15">企业名称</div>
                    <input type="text" class="input fs16 mb25" placeholder="请输入公司全称">
                    <div class="title must fs16 col04 relative mb15">税号</div>
                    <input type="text" class="input fs16 mb25" placeholder="请输入15-20位数和字母">
                    <div class="title fs16 col04 relative mb15">地址和电话</div>
                    <input type="text" class="input fs16 mb25" placeholder="请输入地址和电话">
                    <div class="title fs16 col04 relative mb15">开户行</div>
                    <input type="text" class="input fs16 mb25" placeholder="请输入开户银行">
                    <div class="title fs16 col04 relative mb15">银行卡号</div>
                    <input type="text" class="input fs16 mb25" placeholder="请输入银行卡号">
                    <div class="title fs16 col04 relative mb15">备注</div>
                    <textarea class="textarea fs16 mb50" placeholder="请填写备注"></textarea>
                    <div class="cursor sure fs16 colf flex-box flex-center">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "发票管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            newAddPop: false,
            setDefault: false,
        };
    },
    methods: {
        pageBack() {
            this.$router.go(-1);
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 0 44px 100px;
    background: #fff;

    .title_box {
        height: 100px;
        border-bottom: 1px solid #bccbd9;

        .back::before {
            content: "";
            display: block;
            width: 27px;
            height: 24px;
            background: url('/src/assets/static/icon/c_back.png') no-repeat center;
            background-size: 100%;
            margin-right: 10px;
        }
    }

    .form_box {
        padding: 54px 190px 0;

        .title.must::before {
            display: block;
            content: "";
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #EB3F25;
            position: absolute;
            left: -20px;
            top: -1px;
            bottom: 0;
            margin: auto;
        }

        .sure {
            width: 100%;
            height: 50px;
            border-radius: 8px;
            background: #3D7EFE;
        }

        .input {
            width: 100%;
            height: 50px;
            border-radius: 8px;
            border: 2px solid rgba(98, 134, 171, 0.2);
            padding: 0 24px;
        }

        .input::placeholder {
            color: #909090;
        }

        .type {
            padding-left: 66px;
        }

        .textarea {
            width: 100%;
            height: 134px;
            border-radius: 8px;
            border: 2px solid rgba(98, 134, 171, 0.2);
            padding: 18px 24px;
            resize: none;
        }

        .textarea::placeholder {
            color: #909090;
        }
    }

}
</style>
